import { useTranslation } from "../../lib/i18n";
import { Button } from "../ui/Button";

type BackButtonProps = {
    onClick: () => void;
  };

  export const BackButton = ({ onClick }: BackButtonProps) => {
    const { t } = useTranslation();

    return (
      <Button variant="back" className="flex w-fit gap-2" onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M7.13807 4.47108C7.39842 4.21073 7.39842 3.78862 7.13807 3.52827C6.87772 3.26792 6.45561 3.26792 6.19526 3.52827L2.19526 7.52827C1.93491 7.78862 1.93491 8.21073 2.19526 8.47108L6.19526 12.4711C6.45561 12.7314 6.87772 12.7314 7.13807 12.4711C7.39842 12.2107 7.39842 11.7886 7.13807 11.5283L4.27614 8.66634L13.3333 8.66634C13.7015 8.66634 14 8.36787 14 7.99968C14 7.63149 13.7015 7.33301 13.3333 7.33301L4.27614 7.33301L7.13807 4.47108Z"
            fill="white"
          />
        </svg>
        {t('back')}
      </Button>
    );
  };
